module.exports = __webpack_public_path__ + "media/img/frontend_application/country/my-7818f20177244ab315fb9e6aa86b4bfa.jpg";